import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';
import { ICheckInLogSearchingPayload } from '@/features/check-in-logs/interfaces';
import { CheckInLogService } from '@/features/check-in-logs/services';

export const useCheckInLogsSearching = (payload: ICheckInLogSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.checkInLogsSearching(payload),
    queryFn: () => CheckInLogService.CheckInLogsSearching(payload),
    placeholderData: keepPreviousData,
  });
};
